<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        outlined>
        <v-row>
          
          <v-col cols="12">
            <v-col
              class="d-flex pa-4"
              cols="12"
            >
              <v-select
                :loading="loading"
                :items="editions"
                label="Edición"
                v-model="edition_id"
                name="editions"
                :item-text="'name'"
                :item-value="'id'"
                outlined
                @change="handleSelectChange"
              ></v-select>
            </v-col>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="pa-6"> 
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field> 
              </v-col> 
                
              <v-col cols="12"> 
                <v-data-table
                  class="pt-4"
                  :header-props="headerProps"
                  :headers="headers"
                  :items="entrepreneurs"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :search="search"
                  :custom-filter="customSearch"
                  :items-per-page="50"
                  :footer-props="{
                    'items-per-page-options': [30, 50, 100, 200],
                    'items-per-page-text':'Filas por página'
                  }"
                  mobile="true"
                >
                  <template v-slot:item.user="{ item }">
                    {{ item.lastname.toUpperCase()+', '+item.name }}
                  </template>
                  <template v-slot:item.user_id="{ item }">
                    {{ (item.status==1)?'Registrado':'No registrado' }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      x-small
                      color="primary"
                      @click="showUser(item.id)"
                    >
                      <v-icon dark small>
                        mdi-eye
                      </v-icon>
                    </v-btn>

                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      x-small
                      color="red"
                      @click="confirmDeleteParticipant(item.id)"
                    >
                      <v-icon dark small>
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <!--Dialog show entrepreneurs-->
    <v-dialog
      v-model="dialog_user"
      max-width="750px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Participante</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>              
              
                <v-col cols="12" xl="6" md="6" sm="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Apellido:</b></p>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.lastname }}
                    </v-col>
                  </v-row>
                </v-col>
                  
                <v-col cols="12" xl="6" md="6" sm="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Nombre:</b></p>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" xl="6" md="6" sm="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>DNI/Pasaporte:</b></p>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.dni }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" xl="6" md="6" sm="12" v-if="participant_profile.gender_id">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Genero:</b></p>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.gender.name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" xl="6" md="6" sm="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Correo electrónico:</b></p>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.email }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" xl="6" md="6" sm="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Teléfono:</b></p>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.phone_number }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" xl="6" md="6" sm="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Estudios:</b></p>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.completed_studies }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="3" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Institución a la que pertenece:</b></p>
                    </v-col>
                    <v-col cols="12" md="9" sm="12" class="pb-0 pt-0">
                      {{ participant_profile.institution_you_are_part }}
                    </v-col>
                  </v-row>
                </v-col>

                <template v-if="participant_profile.institution">
                  <v-col cols="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="3" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Institución:</b></p>
                      </v-col>
                      <v-col cols="12" md="9" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.institution }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <template v-if="participant_profile.whatsapp">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Whatsapp:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.whatsapp }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.telegram">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Telegram:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.telegram }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.linkedin">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Linkedin:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.linkedin }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.facebook">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Facebook:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.facebook }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.instagram">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Instagram:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.instagram }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.youtube">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Youtube:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.youtube }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.twitter">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Twitter:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.twitter }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.discord">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Discord:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.discord }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.twitch">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Twitch:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.twitch }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.tiktok">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Tiktok:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.tiktok }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.snapchat">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Snapchat:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.snapchat }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <template v-if="participant_profile.country_id">
                  <v-col cols="12" xl="6" md="6" sm="12" v-if="participant_profile.country.name.toLowerCase()==='argentina'">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Pais:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        Argentina
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Provincia:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.provincia.name }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Localidad:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.localidad.name }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <template v-if="participant_profile.country==='otro'">
                  <v-col cols="12" xl="6" md="6" sm="12">
                    <v-row  class="pb-1 pt-1">
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        <p class="text-lg-right text-sm-left"><b>Pais:</b></p>
                      </v-col>
                      <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                        {{ participant_profile.other_country }}
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="12" xl="6" md="6" sm="12">
                  <v-row  class="pb-1 pt-1">
                    <v-col cols="12" md="6" sm="12" class="pb-0 pt-0">
                      <p class="text-lg-right text-sm-left"><b>Contraseña:</b></p>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="pb-0 pt-0 text-center">
                  <v-btn
                    color="error"
                    :loading="loading_btn"
                    @click="restorePassword(participant_profile.id)">
                    Restablecer contraseña
                  </v-btn>
                </v-col>

                <v-col 
                  cols="12" 
                  class="pb-0 pt-8 text-center" 
                  v-if="new_password">
                  <h4>Contraseña restablecida</h4>
                  <h1 class=" pa-4 font-weight-bold password">
                    {{ new_password }}
                  </h1>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog_user = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="dialog_delete_user"
        width="500"
      >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar a este participante?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="loading_btn"
            @click="dialog_delete_user = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading_btn"
            @click="deleteUser"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'EntrepreneursAdmin',

    data: () => ({
      loading:true,
      loading_btn:false,
      show:false,
      active_tab: 0,

      dialog_user:false,
      dialog_new_user:false,
      dialog_edit_user:false,
      dialog_delete_user: false,

      delete_id:null,

      editions: [],
      edition_id: null,

      id: null,
      name:'',
      lastname:'',
      email:'',
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      new_password:null,

      roles:[],
      entrepreneurs:[],
      participant_profile:[],

      search: '',
      sortBy: 'id',
      sortDesc: true,
      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
        {
          text: 'ID',
          align: 'center',
          filterable: true,
          value: 'id',
          width: '15%'
        },
        {
          text: 'Usuario',
          align: 'start',
          filterable: true,
          value: 'user',
          width: '20%'
        },
        { 
          text: 'Correo Electrónico', 
          value: 'email',
          width: '20%'
        },
        {
          text: 'Institución',
          align: 'start',
          filterable: true,
          value: 'institution',
          width: '20%'
        },
        { 
          text: 'Acciones',
          align: 'center',
          filterable: false,
          value: 'actions',
          width: '15%'
        },
      ],
    }),
    watch: {
      edition_id: {
        handler: function() {
            this.getParticipants()
        },
        deep: true
      }
    },
    methods:{
      customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      },

      async getEditions()
      {
        await axios.get('admin/editions').then(response =>{
          this.editions = response.data
          
          if(this.editions && !this.edition_id){
            this.edition_id = this.editions[0].id
          }
          this.loading=false
        }).catch(error => {
          console.log(error);
          this.loading=false
        })
      },

      async getParticipants()
      {
        this.loading = true
        await axios.get('admin/edition/'+this.edition_id+'/participants').then(response =>{
          this.entrepreneurs = response.data.data.participants_profiles
          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      async showUser(id)
      {
        this.loading = true 
        this.loading_btn = false
        this.new_password = null
        try {
          await axios.get('admin/participants/'+id).then((response) =>{
            this.participant_profile = response.data.data.participant_profile
            this.loading = false
            this.dialog_user = true
            })
        } catch (error) {
          console.log(error.response.data);
          this.message = ''
          this.loading = false
        }
      },

      async restorePassword(id){
        this.loading_btn = true
        await axios.get('admin/participants/'+id+'/restore-password').then(response =>{
          this.new_password = response.data.data.password.password
          this.loading_btn=false
        }).catch(error => {
          console.log(error)
        })
      },

      confirmDeleteParticipant(id){
        this.loading_btn = false
        this.dialog_delete_user = true
        this.delete_id = id
      },

      async deleteUser(){
        
        this.loading_btn = true
        try {
          await axios.delete('admin/participants/'+this.delete_id).then(() =>{
            this.getParticipants()
            this.loading = true
            this.dialog_delete_user = false
            this.dialog = false
          })
        } catch (error) {
          console.error(error.response.data);
          this.message = ''
          this.dialog = false
        }
      },

      createdView()
      {
        this.edition_id = this.$store.state.currentEdition
      },

      handleSelectChange(edition_id)
      {
        this.$store.state.currentEdition = edition_id
      },
    },

    created(){
      Promise.all([
        this.createdView(),
        this.getEditions()
      ]).then(() => {
        this.getParticipants()
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
